import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import Button from '@atlaskit/button/custom-theme-button';
import { baseAppearanceObj } from '../theme';
import { Action, Actions, Container, ContentContainer, Description, IconWrapper, Title } from './styled';

var SectionMessage = /*#__PURE__*/function (_React$Component) {
  _inherits(SectionMessage, _React$Component);

  var _super = _createSuper(SectionMessage);

  function SectionMessage() {
    var _this;

    _classCallCheck(this, SectionMessage);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "renderAction", function (action, linkComponent) {
      var href = action.href,
          key = action.key,
          onClick = action.onClick,
          text = action.text,
          testId = action.testId;
      return /*#__PURE__*/React.createElement(Action, {
        key: key,
        "data-testid": testId
      }, onClick || href ? /*#__PURE__*/React.createElement(Button, {
        appearance: "link",
        spacing: "none",
        onClick: onClick,
        href: href,
        component: href ? linkComponent : undefined
      }, text) : text);
    });

    return _this;
  }

  _createClass(SectionMessage, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          title = _this$props.title,
          actions = _this$props.actions,
          appearance = _this$props.appearance,
          icon = _this$props.icon,
          linkComponent = _this$props.linkComponent,
          testId = _this$props.testId; //needs typecasting because TS is not recognising default props :(

      var appearanceObj = baseAppearanceObj[appearance] || baseAppearanceObj.info;
      var Icon = icon || appearanceObj.Icon;
      return /*#__PURE__*/React.createElement(Container, {
        backgroundColor: appearanceObj.backgroundColor,
        "data-testid": testId
      }, /*#__PURE__*/React.createElement(IconWrapper, null, /*#__PURE__*/React.createElement(Icon, {
        primaryColor: appearanceObj.primaryIconColor,
        secondaryColor: appearanceObj.backgroundColor
      })), /*#__PURE__*/React.createElement(ContentContainer, null, title ? /*#__PURE__*/React.createElement(Title, null, title) : null, children ? /*#__PURE__*/React.createElement(Description, null, children) : null, actions && actions.length ? /*#__PURE__*/React.createElement(Actions, null, actions.map(function (action) {
        return _this2.renderAction(action, linkComponent);
      })) : null));
    }
  }]);

  return SectionMessage;
}(React.Component);

_defineProperty(SectionMessage, "defaultProps", {
  appearance: 'info'
});

export { SectionMessage as default };